import {Component, OnInit} from '@angular/core';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {HeaderComponent} from '../../components/header/header.component';
import {BookingService} from '../../services/booking/booking.service';
import {BookingListItemComponent} from '../../components/booking-list-item/booking-list-item.component';

import {Booking} from '../../../core/entities/booking/booking.entity';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {AccountTabsComponent} from '../../components/account-tabs/account-tabs.component';

@Component({
  selector: 'app-my-account',
  imports: [
    TranslocoPipe,
    BookingListItemComponent,
    HeaderComponent,
    RouterLink,
    AccountTabsComponent
],
  templateUrl: './my-account.component.html',
  styleUrl: './my-account.component.scss'
})
export class MyAccountComponent implements OnInit {
  public incomingBookings: Booking[]|null = null;
  public pastBookings: Booking[]|null = null;

  public constructor(
    private readonly bookingService: BookingService,
    private readonly toastr: ToastrService,
    private readonly transloco: TranslocoService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {
  }

  public ngOnInit() {
    this.handlePaymentStatus();
    this.reloadBookings();
  }

  public reloadBookings(): void {
    this.loadIncomingBookings();
    this.loadPastBookings();
  }

  private loadIncomingBookings(): void {
    this.bookingService.getIncomingBookings().subscribe(
      (bookings) => {
        this.incomingBookings = bookings;
      },
      () => {
        this.toastr.error(
          this.transloco.translate('marketplace.account.bookings.error.content'),
          this.transloco.translate('marketplace.account.bookings.error.title')
        );
      }
    );
  }

  private loadPastBookings(): void {
    this.bookingService.getPastBookings().subscribe(
      (bookings) => {
        this.pastBookings = bookings;
      },
      () => {
        this.toastr.error(
          this.transloco.translate('marketplace.account.bookings.error.content'),
          this.transloco.translate('marketplace.account.bookings.error.title')
        );
      }
    );
  }

  private handlePaymentStatus(): void {
    const paymentStatus = this.route.snapshot.queryParamMap.get('payment');

    if (paymentStatus === 'balance_success') {
      this.toastr.success(
        this.transloco.translate('marketplace.account.bookings.actions.pay-balance.success')
      );
    } else if (paymentStatus === 'balance_cancel') {
      this.toastr.info(
        this.transloco.translate('marketplace.account.bookings.actions.pay-balance.cancel')
      );
    } else {
      return;
    }

    void this.router.navigate([], {
      queryParams: {payment: null},
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
}
